module.exports = __webpack_public_path__ + "static/images/components/ChallengeContent/components/Label/images/wing-left.8a577cc2.png";


//////////////////
// WEBPACK FOOTER
// ./components/ChallengeContent/components/Label/images/wing-left.png
// module id = 2591
// module chunks = 11